// extracted by mini-css-extract-plugin
module.exports = {"listGroup":"PropertyCards-module--list-group--2khI4","propertyCardSummary":"PropertyCards-module--property-card-summary--kjqF_"};